var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"template-container input-text-from-enter-template col"},[_c('span',[_vm._v(" "+_vm._s(_vm.name)+" "),_vm._t("name-link")],2),_vm._t("input"),_c('div',{staticClass:"tooltip-wrapper"},[_c('div',{staticClass:"tooltip-container"},[_vm._t("tooltip")],2)])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }